/* template */
<template><div class="cate-goods-list"><template v-for="(item, index) in (goods)"><good-card :key="item['{{ item.good_id }}']" :good-info="(item)" :lang="(GlobalEnv.lang)" shadow @good-click="onGoodClick(item)" class="good-card-item"/><div ref="sentinel" class="sentinel" v-if="(goods.length > 3 ? index === goods.length - 3 : index === 0)"/></template><loading v-if="(showLoading)"/><empty v-if="(!showLoading && !goods.length)"/></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m25d9b343"}'>
.cate-goods-list
  padding-top 20rpx
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import { createComponent } from '@mpxjs/core'
import { GlobalEnv } from '../../../../lib/webx'
import { MixinList } from '../mixin'
createComponent({
  name: 'CateGoodsList',
  mixins: [ MixinList ],
  properties: {
    cate: Number,
  },
  data: {
    GlobalEnv,
    goods: [],
    page: 1,
    finish: false,
    showLoading: false,
    cateByPage: new Map(),
  },
  watch: {
    cate: {
      handler(newCate) {
        // this.page = 1
        // this.finish = false
        this.getGoods()
      },
      immediate: true,
    },
  },
  methods: {
    async getGoods() {
      this.showLoading = true
      this.cateByPage.set(this.cate, 1)
      const page = this.cateByPage.get(this.cate)
      const { lists, count } = await this.$getGoodsByCates(this.cate, page) || {}
      this.goods = lists || []
      this.finish = this.goods.length >= count
      !this.finish && this.cateByPage.set(this.cate, page + 1)
      this.showLoading = false
      this.observeSentinel()
    },
    // 必须实现，翻页要用
    async loadMore() {
      if (this.finish) return
      this.showLoading = true
      const page = this.cateByPage.get(this.cate)
      const { lists, count } = await this.$getGoodsByCates(this.cate, page) || {}
      if (count) {
        this.goods.push(...(lists || []))
        this.finish = this.goods.length >= count
        !this.finish && this.cateByPage.set(this.cate, page + 1)
      }
      this.showLoading = false
      this.observeSentinel()
    },
  },
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "cate_goods_list25d9b343",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'good-card':getComponent(require("../../../../../node_modules/@didi/trade-sdk/lib/quartz/ui/good_card/index.mpx?component=true&componentId=index4ce63343")),'loading':getComponent(require("./loading.mpx?component=true&componentId=loadingd8a157b0")),'empty':getComponent(require("./empty.mpx?component=true&componentId=empty04f86cf9"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
